import { z } from 'zod';
import { CommonFilter_Config_S, CommonFilter_RequestParams_S, CommonFilter_State_S } from './commonFilter.schema';

/**
 * BOOLEAN FILTER CONFIGURATION
 * */
export const BooleanFilter_KeyWord_S = z.object({
    key: z.union([z.literal(0), z.literal(1)]),
    key_as_string: z.union([z.literal('true'), z.literal('false')]),
    doc_count: z.number(),
});

export const BooleanFilter_Config_S = CommonFilter_Config_S.extend({
    type: z.literal('boolean'),
    values: z.object({
        keywords: z.array(BooleanFilter_KeyWord_S),
    }),
});

/**
 * BOOLEAN FILTER STATE
 * */
export const BooleanFilter_State_S = BooleanFilter_Config_S.merge(CommonFilter_State_S);

/**
 * BOOLEAN FILTER CONTROLS STATE
 */
export const BooleanFilter_ControlsState_S = BooleanFilter_Config_S.pick({ identifier: true, type: true }).extend({
    values: z.object({
        isChecked: z.boolean(),
    }),
    applyFilter: z.boolean(),
});

/**
 * BOOLEAN FILTER REQUEST PARAMS
 * */
export const BooleanFilter_RequestParams_S = CommonFilter_RequestParams_S.extend({
    checked: z.boolean(),
});

/**
 * BOOLEAN FILTER SNAPSHOT
 * */
export const BooleanFilter_Snapshot_S = z.string(); // only the identifier is sufficient

/**
 * BOOLEAN FILTER STATE AGGREGATION RESPONSE
 * */
export const BooleanFilterAggregation_S = z.array(
    z.object({
        key: z.union([z.literal(0), z.literal(1)]),
        doc_count: z.number(),
    })
);
